import React from 'react';
import PropTypes from 'prop-types';
import {
  Card,
  CardActions,
  CardHeader,
  CardContent,
  Divider,
  Button,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
} from '@material-ui/core';
import {Schedule} from '@material-ui/icons';
import {purple} from '@material-ui/core/colors';

function ImportedProcedureProperties(props) {
  const {selectedProcedure} = props;

  return !!selectedProcedure ? (
    <Card>
      <CardHeader
        title={
          selectedProcedure.cnsProcedure ? selectedProcedure.cnsProcedure.name : '-- No Name --'
        }
        subheader="Properties"
      />
      <Divider />
      <CardContent style={{overflow: 'auto', whiteSpace: 'nowrap'}}>
        <List>
          <ListItem style={{wordWrap: 'break-word', whiteSpace: 'normal'}}>
            <ListItemIcon>
              <Schedule />
            </ListItemIcon>
            <ListItemText
              primary="Created Date"
              secondary={new Date(selectedProcedure.createdDt).toLocaleDateString('en-AU')}
            />
          </ListItem>
          <ListItem style={{wordWrap: 'break-word', whiteSpace: 'normal'}}>
            <ListItemIcon>
              <Schedule />
            </ListItemIcon>
            <ListItemText
              primary="Last Modified Date"
              secondary={new Date(selectedProcedure.modifiedDt).toLocaleDateString('en-AU')}
            />
          </ListItem>
        </List>
      </CardContent>
      <CardActions>
        <Button
          variant="outlined"
          href={`/#/Procedures/${selectedProcedure.id}/update`}
          style={{color: purple[500]}}
        >
          Edit
        </Button>
      </CardActions>
    </Card>
  ) : (
    <Card>
      <CardHeader title="Procedure Properties" subheader="No Imported Procedure Selected" />
    </Card>
  );
}

ImportedProcedureProperties.propTypes = {
  selectedProcedure: PropTypes.object,
};

ImportedProcedureProperties.defaultProps = {
  selectedProcedure: null,
};

export default ImportedProcedureProperties;
